import React from 'react';

function TableHeader() {
    return (
        <thead>
            <tr>
                <th className="" rowSpan="4" colSpan="1">
                    SL
                </th>
                <th className="" rowSpan="4" colSpan="1">
                    Subscription Title
                </th>
                <th className="" rowSpan="4" colSpan="1">
                    Amount
                </th>
                <th className="" rowSpan="4" colSpan="1">
                    Currency
                </th>
            </tr>
        </thead>
    );
}

function DetailsReportTable() {
    return (
        <div className="pb-10 print:pb-0">
            <table className="report-table" cellPadding={0} cellSpacing={0}>
                <TableHeader />
                <tbody>
                    <tr>
                        <td>01</td>
                        <td>Envision NEXT - Date PHP5</td>
                        <td>3,574.50</td>
                        <td>USD</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

export default DetailsReportTable;
